export default {
    expiryAndCvvContainer: {
        display: "flex",
        gap: "20px",
    },
    expiryAndCvvField: {
        flex: 1
    }
}